/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */

export const dropdownStyles = {
	root: {
		width: 220,
	},
}

/**
 * For dropdowns that are part of a removable row (e.g., having a delete button at the end)
 */
export const removableDropdownStyles = {
	root: {
		width: 188,
	},
}
/**
 * For side-by-side dropdowns with a 12px gap
 */
export const narrowDropdownStyles = {
	root: {
		width: 135,
	},
}
